import isError from 'lodash/isError';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import { flattenObject } from './objects';

export const formatResponseError = (error) => {
    if (!isError(error) && !error.response.status <= 300) {
        return { generic: null, fields: {} };
    }
    
    if (!error.response) {
        return { generic: null, fields: {} };
    }

    if (error.response.status >= 500) {
        return {
            generic: isObject(error.response.data) && error.response.data.detail
                ? error.response.data.detail
                : 'Internal Server Error',
            fields: {}
        };
    } else if (isArray(error.response.data) && error.response.data.length > 0) {

        if (isString(error.response.data[0])) {
            return { generic: error.response.data[0], fields: {} };
        }

    } else if (isObject(error.response.data) && error.response.data.detail) {
        return { generic: error.response.data.detail, fields: {} };
    } else if (isObject(error.response.data)) {

        if ('non_field_errors' in error.response.data) {
            return { generic: error.response.data.non_field_errors[0], fields: {} };
        } else {
            return { generic: null, fields: flattenObject(error.response.data) };
        }

    }

    return { generic: 'Unknown Error', fields: {} };
}

export const getFilenameFromResponse = (response) => {
    return response.headers['content-disposition'].split(';')[1].split('=')[1].split('"')[1].trim();
}

export const convertBlobResponseToJson = async (response) => {
    const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
    const responseData = isJsonBlob(response?.data) ? await (response?.data)?.text() : response?.data || {};
    const responseJson = (typeof responseData === "string") ? JSON.parse(responseData) : responseData;
    return responseJson
}


export const getCookieByName = (name) => {
    const cookies = document.cookie.split('; ');
    for (let cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) {
            return decodeURIComponent(value);
        }
    }
    return null;
}

export const setPageTitle = (name) => {
    if (name) document.title = name;
}
